import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import * as ReactDOMClient from 'react-dom/client';
import { I18nextProvider } from 'react-i18next'
import App from 'App'
import i18n from 'utilities/i18n'
import * as Sentry from "@sentry/react";
import values from 'object.values'
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import ReactGA from 'react-ga'
import DisableMultiTab from 'App/Travel/DisableMultiTab';

// Initialize Sentry
Sentry.init({
  dsn: window.SENTRY_PUBLIC_DSN,
  release: window.RELEASE_VERSION,
});

if (!Object.values) {
  values.shim();
}

export const logRocketInit = (appid) => {
  LogRocket.init(appid, {
    dom: {
      baseHref: window.location.origin,
      // Added to sanitize all input fields
      inputSanitizer: true,
    },
    network: {
      requestSanitizer: request => {
        request.body = null;
        return request;
      },
      responseSanitizer: response => {
        if (response.body) {
          if (typeof response.body === "string") {
            try {
              let sanitized = { sanitized: "sanitized" }
              let body = JSON.parse(response.body)
              let body_data = body.data
              if (body.data) {
                if (JSON.stringify(body_data).includes("first_name_")) {
                  body.data = sanitized
                }
              }
              if (body.travellers) {
                body.travellers = sanitized
              }
              if (body.rating_data) {
                body.rating_data = sanitized
              }
              if (body.extra) {
                let extra = body.extra
                if (extra.travellers) {
                  extra.travellers = sanitized
                }
                if (extra.quote_travellers) {
                  extra.quote_travellers = sanitized
                }
                if (extra.token) {
                  extra.token = sanitized
                }
                if (extra.quotes) {
                  let quotes = extra.quotes
                  quotes.map((q) => {
                    if (q.travellers) {
                      q.travellers.map((t) => t.traveller = sanitized)
                    }
                    if (q.premiums) {
                      q.premiums.map((p) => p.travellers = sanitized)
                    }
                  })
                }
              }
              if (body.quotes) {
                let quotes = body.quotes
                quotes.map((q) => {
                  if (q.premiums) {
                    q.premiums.map((p) => p.travellers = sanitized)
                  }
                })
              }
              if (body.all_quotes) {
                let all_quotes = body.all_quotes
                all_quotes.map((q) => {
                  if (q.premiums) {
                    q.premiums.map((t) => t.travellers = sanitized)
                  }
                })
              }
              response.body = JSON.stringify(body)
            }
            catch (error) {
              console.log(error)
            }
          }
        }
        return response;
      },
    },
  })
}

if (window.Details.LOGROCKET === "True") {
  if (window.Details.PROD === "True") {
    logRocketInit('e8r9ss/trillium-prod');
  } else if (window.Details.STAGE === "True") {
    logRocketInit('e8r9ss/trillium-stage');
  } else {
    logRocketInit('e8r9ss/trillium-dev');
  }
}
setupLogRocketReact(LogRocket);

LogRocket.getSessionURL(sessionURL => {
  Sentry.getCurrentScope().setExtra('sessionURL', sessionURL);
  const sessionId = sessionURL.split('/').slice(-1)[0];
  Sentry.setTag('logrocketSessionId', sessionId);
});

export const fireTracking = () => {
  if (window.OnetrustActiveGroups && window.OnetrustActiveGroups.includes("C0004")) {
    ReactGA.set({ page: window.location.pathname })
    ReactGA.pageview(window.location.pathname)
  }
  return false
}

const supportsHistory = 'pushState' in window.history
const rootDiv = document.getElementById('root')
const root = ReactDOMClient.createRoot(rootDiv)

// SINGLE TAB ENFORCEMENT LOGIC
const channel = new BroadcastChannel('app_session_channel');
let isDuplicateTab = false;

channel.onmessage = (event) => {
  if (event.data === 'REQUEST_TAB_CHECK') {
    channel.postMessage('TAB_EXISTS');
  }

  if (event.data === 'TAB_EXISTS') {
    isDuplicateTab = true;

    const removeOneTrust = () => {
      const banner = document.getElementById('onetrust-banner-sdk');
      const consent = document.getElementById('onetrust-consent-sdk');
      if (banner) banner.remove();
      if (consent) consent.remove();
    };

    // try to remove immediately
    removeOneTrust();

    // Set an interval to keep checking and removing it (in case it loads late)
    const cleanerInterval = setInterval(removeOneTrust, 100);

    // Replace the app with an error screen immediately
    root.render(
      <I18nextProvider i18n={i18n}>
        <Router forceRefresh={!supportsHistory}>
          <DisableMultiTab />
        </Router>
      </I18nextProvider>
    );

    channel.close(); // Stop listening
  }
};

// Send a ping to ask if any other tabs are open
channel.postMessage('REQUEST_TAB_CHECK');

root.render(
  // <Provider store={store}>
  <I18nextProvider i18n={i18n}>
    <Router forceRefresh={!supportsHistory}>
      <App fireTracking={fireTracking} />
    </Router>
  </I18nextProvider>
  // </Provider>,
  // rootDiv
)
